'use client';
import React, { useRef } from 'react';
import { ProductItem } from './ProductItem';
import { cn } from '@/app/lib/utils';
import { Pagination } from '@workspace/ui/common/Pagination';
import { IProductItem } from './interfaces';

interface ProductListProps {
  products: IProductItem[];
  className?: string;
  gridCols?: 1 | 2 | 3 | 4 | 5 | 6;
  gap?: 'sm' | 'md' | 'lg' | 'xl';
  ctaText?: string;
  // Pagination props
  currentPage?: number;
  totalPages?: number;
  totalItems?: number;
  itemsPerPage?: number;
  onPageChange?: (page: number) => void;
  onItemsPerPageChange?: (itemsPerPage: number) => void;
  showPagination?: boolean;
  showItemsPerPageSelector?: boolean;
  onScrollToTop?: () => void;
}

export function ProductList({
  products,
  className = '',
  // gridCols = 4,
  // gap = 'md',
  ctaText = 'View detail',
  currentPage = 1,
  totalPages = 1,
  totalItems = 0,
  itemsPerPage = 12,
  onPageChange,
  onItemsPerPageChange,
  showPagination = false,
  showItemsPerPageSelector = true,
  onScrollToTop,
}: ProductListProps) {
  const paginationRef = useRef<HTMLDivElement>(null);

  // Generate grid classes - always 2 on mobile, 4 on desktop
  const getGridClasses = () => {
    return 'grid-cols-2 lg:grid-cols-4';
  };

  return (
    <div className="product-list-container">
      <div className={cn('grid gap-x-4 gap-y-12 sm:gap-x-5', getGridClasses(), className)}>
        {products.map((product) => (
          <ProductItem key={product._id} product={product} text={ctaText} />
        ))}
      </div>

      {showPagination && onPageChange && onItemsPerPageChange && totalItems > itemsPerPage && (
        <div ref={paginationRef} className="px-4 sm:px-6 xl:px-4xl">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
            onItemsPerPageChange={onItemsPerPageChange}
            variant="jumper"
            className="mt-16 items-center !justify-center gap-2"
            showItemsPerPageSelector={showItemsPerPageSelector}
            onScrollToTop={onScrollToTop}
          />
        </div>
      )}
    </div>
  );
}
